import { useMemo, useRef } from 'react';

const debounce = <Arguments extends unknown[]>(
  debouncedFunction: (...args: Arguments) => void,
  time: number
) => {
  let interval: number;
  return (...args: Arguments) => {
    window.clearTimeout(interval);
    interval = window.setTimeout(() => {
      debouncedFunction(...args);
    }, time);
  };
};

export const useDebounce = <Arguments extends unknown[]>(
  debouncedFunction: (...args: Arguments) => void,
  time: number
) => {
  const debouncedFunctionRef = useRef(debouncedFunction);
  debouncedFunctionRef.current = debouncedFunction;

  return useMemo(
    () => debounce((...args: Arguments) => debouncedFunctionRef.current(...args), time),
    [time]
  );
};
